import { cn } from "@acme/utils";
import * as React from "react";

function SettingsSection({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <section
      data-slot="settings-section"
      className={cn(
        "bg-card text-card-foreground rounded-xl border shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

function SettingsSectionHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="settings-section-header"
      className={cn(
        "flex flex-col gap-1 border-b px-6 py-5 sm:flex-row sm:items-start sm:justify-between sm:gap-4",
        className,
      )}
      {...props}
    />
  );
}

function SettingsSectionTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2
      data-slot="settings-section-title"
      className={cn("text-base font-semibold tracking-tight", className)}
      {...props}
    />
  );
}

function SettingsSectionDescription({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      data-slot="settings-section-description"
      className={cn("text-muted-foreground text-sm", className)}
      {...props}
    />
  );
}

function SettingsSectionHeaderContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="settings-section-header-content"
      className={cn("flex flex-col gap-1", className)}
      {...props}
    />
  );
}

function SettingsSectionHeaderActions({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="settings-section-header-actions"
      className={cn("flex shrink-0 items-center gap-2", className)}
      {...props}
    />
  );
}

function SettingsSectionContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="settings-section-content"
      className={cn("px-6 py-5", className)}
      {...props}
    />
  );
}

function SettingsSectionFooter({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="settings-section-footer"
      className={cn(
        "bg-muted/50 flex items-center justify-end gap-2 rounded-b-xl border-t px-6 py-3",
        className,
      )}
      {...props}
    />
  );
}

export {
  SettingsSection,
  SettingsSectionContent,
  SettingsSectionDescription,
  SettingsSectionFooter,
  SettingsSectionHeader,
  SettingsSectionHeaderActions,
  SettingsSectionHeaderContent,
  SettingsSectionTitle,
};
